import type { TFunction } from 'i18next';
import { z } from 'zod';

import type { GetTermDetailResponse } from '@/api/generated/schemas';

/**
 * Factory pro Zod schéma editace termínu. Lokalizované hlášky se vkládají přímo do schématu (single source of
 * truth), proto se staví z `t` až za běhu. V této iteraci je editovatelný pouze kód termínu; ostatní údaje
 * (datumy, počet nocí) jsou readonly a do formuláře nevstupují.
 */
export function buildTermDetailFormSchema(t: TFunction) {
  return z.object({
    code: z
      .string()
      .trim()
      .min(1, t('termDetail.validation.codeRequired'))
      .max(50, t('termDetail.validation.codeMaxLength')),
  });
}

export type TermDetailFormValues = z.infer<ReturnType<typeof buildTermDetailFormSchema>>;

/** Mapuje načtený detail termínu na výchozí hodnoty formuláře. */
export function fromGetTermDetailResponse(detail: GetTermDetailResponse): TermDetailFormValues {
  return {
    code: detail.code,
  };
}
